document.addEventListener('DOMContentLoaded', function () {
  const initSlider = () => {
    const swiperElement = document.querySelector('.custom-collections__grid');
    if (!swiperElement) return;

    let swiperInstance = null;
    const mediaQuery = window.matchMedia('(max-width: 749px)');

    const handleMediaQueryChange = (e) => {
      if (e.matches) {
        if (!swiperInstance) {
          swiperInstance = new Swiper(swiperElement, {
            slidesPerView: 1.2,
            spaceBetween: 20,
            pagination: {
              el: '.custom-collections-pagination',
              clickable: true,
            },
            breakpoints: {
              480: {
                slidesPerView: 1.5,
                spaceBetween: 20
              },
              600: {
                slidesPerView: 2.2,
                spaceBetween: 30
              }
            }
          });
        }
      } else {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      }
    };

    mediaQuery.addEventListener('change', handleMediaQueryChange);
    handleMediaQueryChange(mediaQuery);
  };

  initSlider();

  // Support for Shopify Design Mode
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('custom-collections-section')) {
      initSlider();
    }
  });
});
